export default __webpack_public_path__ + "static/media/loading-simple.feb6606e.svg";